import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Modal, Table } from 'reactstrap';

export const Container = styled.div`
  height: calc(100vh - 60px);
  padding: 20px;
  overflow-y: scroll;
  padding-bottom: 100px;
`;

export const NavDiv = styled.div`
  display: flex;
  justify-content: space-between;

  margin-left: 70px;
  margin-right: 60px;

  @media (max-width: 1440px) {
    margin-left: 50px;
  }
`;

export const NavDivTeste = styled.div`
  width: 90%;
  padding-left: 10px;
  margin-bottom: 5px;
  margin-left: -6px;
`;

export const NavLinkSpan = styled.span`
  margin-right: 5px;
`;

export const InputsTable = styled.table`
  min-width: 200px;
  width: 100%;
  margin: 15px auto 15px 0;
  border-collapse: initial;
  border-spacing: 0 20px;
  background: ${(props) => props.theme.colors.white};
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  border-radius: 8px;
  padding: 0 30px;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    tr {
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    td {
      border-bottom: 1px solid transparent;
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;

  @media (max-width: 1600px) {
  }
`;

export const ErrorContainer = styled.div`
  width: 60%;
  min-width: 600px;
  margin: 10px auto 30px auto;

  background: orange;
  color: #fff;

  border-radius: 8px;
  padding: 30px;

  p {
    text-align: center;
    font-size: 22px;
  }
`;

export const SearchDiv = styled.div`
  width: fit-content;
  height: 38px;
  padding-bottom: 5px;
  min-width: 200px;
  display: flex;
  gap: 5px;
  align-items: center;
  float: right;
  border-collapse: separate;
  border-spacing: 0 20px;

  [class*='-container'] {
    width: 140px;
  }

  input {
    width: 210px !important;
  }

  @media (min-width: 1600px) {
    margin-right: 0px;
    form {
      input {
        margin-right: 25px;
      }
    }
  }
`;

export const ComplementsTable = styled.div`
  width: 100%;
  min-width: 200px;
  margin: 0 auto;
  box-shadow: 1px 0px 5px 1px rgba(0, 0, 0, 0.1);
  background: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  padding: 0 20px;
`;

export const StyledTable = styled(Table)`
  border-collapse: separate;
  border-spacing: 0 20px;

  thead {
    text-align: left;
    tr {
      th:first-child {
        text-align: left !important;
      }
      th {
        border-bottom: 1px solid #c4c4c4 !important;
        padding-bottom: 24px;
        text-align: center !important;
      }
      th:last-child {
        text-align: right;
      }
    }
  }

  tbody {
    tr {
      td:first-child {
        text-align: left !important;
      }
      td {
        border-bottom: 1px solid #f4f4f4 !important;
        text-align: center !important;
      }
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;

export const Delete = styled.button`
  border: none;
  background: none;

  &:active {
    border: none;
  }

  svg {
    color: ${(props) => props.theme.colors.secondary};
  }
`;

export const DeleteFilterButton = styled.button`
  width: 78px;
  height: 38px;
  border: none;
  background: #2ec9b7;
  color: #fff;
  padding: 8px 10px;
  border-radius: 12px;
`;

export const InventaryButton = styled.button`
  border: none;
  background: transparent;
  color: #2ec9b7;
  font-weight: bold;
  border-radius: 4px;
  text-decoration: underline;
  font-size: 16px;
`;

export const InputInfoArea = styled.div`
  width: 756px;
  border: 1px solid #c6c6c6;
  border-radius: 12px;
  padding: 12px;
  margin-top: 20px;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const InputLine = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const TableArea = styled.div`
  width: 756px;
  overflow: hidden;
  margin-top: 8px;
`;

export const TableStyled = styled.div`
  max-height: 200px;
  overflow-y: auto;
  display: block;
  width: 100%;
  border-radius: 12px;

  table {
    width: 100%;
    border-spacing: 0px 1px;
    border-collapse: separate;
    background-color: #ededed;

    thead {
      position: sticky;
      top: 0;
      z-index: 0;
      background-color: #ededed;

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        th {
          text-align: center;
          font-weight: bold;
          padding: 4px 12px;
          font-size: 12px;
        }
      }
    }

    tbody {
      display: block;
      max-height: 300px;
      overflow-y: auto;

      tr {
        display: table;
        table-layout: fixed;
        width: 100%;

        td {
          text-align: center;
          background-color: #fff;
          padding: 10px;
          font-size: 12px;

          &:first-child {
            border-left: 1px solid #ededed;
          }

          &:last-child {
            border-right: 1px solid #ededed;
          }
        }
      }

      tr:last-child td:first-child {
        border-bottom-left-radius: 8px;
      }

      tr:last-child td:last-child {
        border-bottom-right-radius: 8px;
      }
    }

    tfoot {
      position: sticky;
      bottom: 0;
      z-index: 1;
      background-color: #ededed;

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        td {
          text-align: center;
          font-size: 12px;
          padding: 4px 8px; /* Menor padding */
          line-height: 1.2; /* Menor altura da linha */
          font-weight: 600;
          background-color: #ededed;
        }
      }
    }
  }

  tbody::-webkit-scrollbar {
    width: 7px; /* Define a largura da scrollbar */
  }
`;

export const ModalStyled = styled(Modal)`
  .modal-content {
    width: 788px;
    max-height: 90vh;
    overflow-y: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .modal-header {
    padding: 16px;
    padding-bottom: 0px;
  }

  .modal-body {
    padding: 16px;
    flex: 1;
  }
`;

export const FooterModal = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  background: #fff;
  padding: 16px;
  z-index: 0;
`;

export const InfoDiv = styled.div`
  display: flex;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 12px;
  background: #f6f6f6;

  p {
    color: #545454;
    text-align: center;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.1px;
  }

  span {
    color: #222;
    text-align: center;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.1px;
  }
`;

export const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 8px;
    width: 400px;
    margin-left: 32px;
  }
`;

export const Overlay = styled.div `
     position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.37);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
`


export const ContainerToUpdate = styled.div`
  display: flex;
  width: 450px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  background: #FFF;

  /* 03 */
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12);
`

export const BodyToUpdate = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  `


export const ContainerText = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TextHeader = styled.span`
  color: ${({ $bold }) => $bold ? 'var(--Takeat-Colors-Neutrals-Black-01, #222)' : 'color: var(--Takeat-Colors-Neutrals-Grey-01, #545454)'};

  /* Title/Title Medium/Semibold | 600 */
  font-family: Poppins;
  font-size: ${({ $bold }) => $bold ? '18px' : '14px'};
  font-style: normal;
  font-weight: ${({ $bold }) =>  $bold ? '600' : '500'};
  line-height:  ${({ $bold }) => $bold ? '24px' : '20px' };
  letter-spacing: var(--Headline-Small-Tracking, 0px);
  `